import flatpickr from 'flatpickr';

const formFieldClass = '.js-form_field';
const invalidClass = 'm-invalid';

const defaultOptions = {
  dateFormat: 'd/m/Y',
  allowInput: true,
  disableMobile: true,
};

export function initDatepicker(selector, options = {}) {
  const elements =
    typeof selector === 'string'
      ? document.querySelectorAll(selector)
      : [selector];

  elements.forEach((el) => {
    const instance = flatpickr(el, {
      ...defaultOptions,
      ...options,
      onChange(selectedDates, dateStr, fp) {
        if (dateStr) {
          fp.element.closest(formFieldClass)?.classList.remove(invalidClass);
        }
        options.onChange?.(selectedDates, dateStr, fp);
      },
    });

    // Prevent blur-validation while the calendar is open (blur fires before
    // flatpickr sets the value, causing a validation flash).
    el.addEventListener('blur', (e) => {
      if (instance.isOpen) e.stopImmediatePropagation();
    }, true);
  });
}
